import { render, staticRenderFns } from "./SalesInvoice.vue?vue&type=template&id=36d77d86&"
import script from "./SalesInvoice.vue?vue&type=script&lang=js&"
export * from "./SalesInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports